<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-alert
          v-model="showDeleteSuccessAlert"
          type="success"
          dismissible
          close-icon="mdi-delete"
          outlined
        >
          Transaction category was deleted successfully!
        </v-alert>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-select
          v-model="jurnal_accounts"
          :items="activeAccounts"
          :menu-props="{ maxHeight: '400' }"
          label="Select"
          :item-text="(item) => item.name + ' - ' + item.amount"
          item-value="id"
          multiple
          persistent-hint
        >
        </v-select>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-menu
          ref="fromDateMenu"
          v-model="fromDateMenu"
          :close-on-content-click="false"
          :return-value.sync="fromDate"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="fromDate"
              label="From date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="fromDate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="fromDateMenu = false"
              >Cancel</v-btn
            >
            <v-btn
              text
              color="primary"
              @click="$refs.fromDateMenu.save(fromDate)"
              >OK</v-btn
            >
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-menu
          ref="toDateMenu"
          v-model="toDateMenu"
          :close-on-content-click="false"
          :return-value.sync="toDate"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="toDate"
              label="To date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="toDate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="toDateMenu = false"
              >Cancel</v-btn
            >
            <v-btn text color="primary" @click="$refs.toDateMenu.save(toDate)"
              >OK</v-btn
            >
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-btn large block color="primary" @click="filterJurnal">Filter</v-btn>
      </v-col>
    </v-row>
    <v-row v-if="loaded">
      <v-spacer></v-spacer>
      <v-col cols="12" sm="6" md="3">
        <v-btn class="float-right ml-6" color="primary" @click="exportExcel"
          >Export</v-btn
        >
        <v-btn
          class="float-right"
          color="primary"
          @click="showCalendar = !showCalendar"
          >Calendar</v-btn
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col style="height: 100%">
        <v-row v-if="showCalendar">
          <vue-cal
            ref="test"
            height="300px"
            active-view="week"
            hide-view-selector
            :time="false"
            :min-date="minDate"
            :max-date="maxDate"
            class="vuecal--blue-theme"
            :selected-date="selectedDate"
            :disable-views="['years', 'year', 'month', 'day']"
          >
            <template #arrow-prev>
              <v-icon
                color="#ffffff"
                v-if="$refs.test && minDate < $refs.test.view.startDate"
                >mdi-chevron-left</v-icon
              >
              <span v-else></span>
            </template>
            <template #title="{ title }">
              {{ title }}
            </template>
            <template #arrow-next>
              <v-icon
                color="#ffffff"
                v-if="$refs.test && maxDate > $refs.test.view.endDate"
                >mdi-chevron-right</v-icon
              >
              <span v-else></span>
            </template>
            <template #weekday-heading="{ heading }">
              {{ heading.label }}
            </template>
            <template v-slot:cell-content="{ title, cell }">
              <div class="pa-2">
                <div
                  class="vuecal__cell-date font-weight-bold"
                  style="font-size: 1rem"
                >
                  {{ cell.formattedDate }}
                </div>
                <v-divider />
                <p class="text-center mt-3 mb-0">
                  Start:
                  {{
                    balances[cell.endDate.toISOString().substring(0, 10)]
                      ? balances[cell.endDate.toISOString().substring(0, 10)]
                          .opening_amount
                      : ""
                  }}
                </p>
                <p class="text-center ma-0 light-green--text">
                  +{{
                    balances[cell.endDate.toISOString().substring(0, 10)]
                      ? balances[cell.endDate.toISOString().substring(0, 10)]
                          .income
                      : ""
                  }}
                </p>
                <p class="text-center ma-0 light-blue--text">
                  {{
                    balances[cell.endDate.toISOString().substring(0, 10)]
                      ? balances[cell.endDate.toISOString().substring(0, 10)]
                          .transfers
                      : ""
                  }}
                </p>
                <p class="text-center ma-0 red--text">
                  -{{
                    balances[cell.endDate.toISOString().substring(0, 10)]
                      ? balances[cell.endDate.toISOString().substring(0, 10)]
                          .expense
                      : ""
                  }}
                </p>
                <p class="text-center ma-0">
                  End:
                  {{
                    balances[cell.endDate.toISOString().substring(0, 10)]
                      ? balances[cell.endDate.toISOString().substring(0, 10)]
                          .closing_amount
                      : ""
                  }}
                </p>
              </div>
            </template>
          </vue-cal>
          <v-container>
            <p class="text-center ma-0 mt-3">
              Selected Project: {{ activeProject.name }}
            </p>
            <p class="text-center ma-0">
              Selected Account(s): {{ selectedAccounts }}
            </p>
            <p class="text-center ma-0">
              Selected period: {{ minDate.toISOString().substring(0, 10) }} -
              {{ maxDate.toISOString().substring(0, 10) }}
            </p>
            <p class="text-center ma-0">
              Start: {{ firstBalance && firstBalance.opening_amount }}
            </p>
            <p class="text-center ma-0 light-green--text">
              +{{ balances.total_income }}
            </p>
            <p class="text-center ma-0 light-blue--text">
              {{ balances.total_transfers }}
            </p>
            <p class="text-center ma-0 red--text">
              -{{ balances.total_expense }}
            </p>
            <p class="text-center ma-0 mb-3">
              End: {{ lastBalance && lastBalance.closing_amount }}
            </p>
            <v-divider />
          </v-container>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="transactions"
          :items-per-page="15"
          :item-class="getRowClass"
          no-data-text="There are no transactions to show for the applied filter"
          class="elevation-2"
        >
          <template v-slot:item.type="{ item }">
            {{ formatType(item.type) }}
          </template>
          <template v-slot:item.date="{ item }">
            {{ formatDate(item.date) }}
          </template>
          <template v-slot:item.period="{ item }">
            {{ formatPeriod(item.period) }}
          </template>
          <template v-slot:item.debit="{ item }">
            {{ formatFromAccount(item) }}
          </template>
          <template v-slot:item.credit="{ item }">
            {{ formatToAccount(item) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="setEditTransaction(item)">
              mdi-pencil
            </v-icon>
            <v-icon small class="mr-2" @click="confirmDeleteTransaction(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog v-model="deleteDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Please confirm</v-card-title>
        <v-card-text> You are about to delete this transaction. </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false"> Close </v-btn>
          <v-btn color="green darken-1" text @click="deleteTransaction">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { json2excel } from "js2excel";
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

export default {
  components: { VueCal },
  data() {
    return {
      showCalendar: false,
      jurnal_accounts: [],
      loaded: false,
      fromDate: "",
      toDate: "",
      fromDateMenu: false,
      toDateMenu: false,
      deleteDialog: false,
      showDeleteSuccessAlert: false,
      activeItem: null,
      headers: [
        { text: "Type", value: "type" },
        { text: "User", value: "user" },
        { text: "Date", value: "date" },
        { text: "Period", value: "period" },
        { text: "Description", value: "description" },
        { text: "Amount", value: "amount" },
        { text: "Debit Account", value: "debit" },
        { text: "Credit Account", value: "credit" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      selectedDate: "",
    };
  },
  created() {
    let currentFilter = this.$store.state.currentFilter;
    if (currentFilter) {
      this.fromDate = currentFilter.jurnal_from_date;
      this.toDate = currentFilter.jurnal_to_date;
      this.jurnal_accounts = currentFilter.jurnal_accounts;
      // Trigger the filtering if needed or just set up the initial filter state
    }
  },
  methods: {
    exportExcel() {
      var transactions = this.transactions;
      var data = [];

      transactions.forEach((element) => {
        var el = {
          Type: this.formatType(element.type),
          User: element.user,
          Date: this.formatDate(element.date),
          Period: this.formatPeriod(element.period),
          Description: element.description,
          Amount: element.amount,
          "Debit Account": this.formatFromAccount(element),
          "Credit Account": this.formatToAccount(element),
        };
        data.push(el);
      });

      try {
        json2excel({
          data,
          name: "transactions-export",
          formateDate: "yyyy/mm/dd",
        });
      } catch (e) {
        console.error("export error");
      }
    },
    getRowClass(item) {
      if (item.type === "income") {
        return "teal lighten-4";
      }

      if (item.type === "expense") {
        return "red lighten-4";
      }

      return "light-blue lighten-4";
    },
    formatFromAccount(item) {
      const account = this.accounts.find(
        (account) => account.id === item.from_account_id
      );
      if (!account) return "-";
      return account.name;
    },
    formatToAccount(item) {
      if (item.type === "transfer") {
        const account = this.accounts.find(
          (account) => account.id === item.to_account_id
        );
        if (!account) return "-";
        return account.name;
      }

      const category = this.transactionCategories.find(
        (category) => category.id === item.transaction_category_id
      );

      if (!category) return "-";

      return category.name;
    },
    formatType(type) {
      if (type === "income") {
        return "Debit";
      }

      if (type === "expense") {
        return "Credit";
      }

      return "Transaction";
    },
    formatDate(date) {
      var d = new Date(date * 1000);
      return d.toLocaleDateString();
    },
    formatPeriod(date) {
      var d = new Date(date * 1000);
      return d.toLocaleDateString().substr(3);
    },
    filterJurnal() {
      var filter = {
        jurnal_from_date: this.fromDate,
        jurnal_to_date: this.toDate,
        jurnal_accounts: this.jurnal_accounts,
        project_id: this.activeProjectId,
      };
      this.$store.commit("SET_CURRENT_FILTER", filter); // Update the Vuex state with the current filter
      this.$store.dispatch("loadTransactions", filter).then(() => {});

      filter = {
        accounts: this.jurnal_accounts,
        balance_from_date: this.fromDate,
        balance_to_date: this.toDate,
      };
      this.$store.dispatch("loadBalances", filter).then(() => {});

      this.loaded = true;
    },
    parseErrors(result) {
      var errors = result.response.data.errors;
      let keys = Object.keys(errors);
      this.errors = [];

      keys.forEach((key) => {
        let item = errors[key];
        item.forEach((error) => {
          this.errors.push(error);
        });
      });
    },
    refreshData() {
      this.jurnal_accounts = []; // Assuming you want to clear the selected accounts
      this.fromDate = ""; // Clear or set to a default value
      this.toDate = ""; // Clear or set to a default value

      this.filterJurnal();
    },
    setEditTransaction(item) {
      var localItem = {
        ...item,
      };
      localItem.date = new Date(item.date * 1000).toISOString().substr(0, 10);
      localItem.period = new Date(item.period * 1000)
        .toISOString()
        .substr(0, 7);
      this.$store.dispatch("setIsEdit", true);
      this.$store.dispatch("setDialog", true);
      this.$store.dispatch("setActiveItem", localItem);
    },
    confirmDeleteTransaction(item) {
      this.activeItem = item;
      this.deleteDialog = true;
    },
    deleteTransaction() {
      this.$store
        .dispatch("deleteTransaction", this.activeItem.id)
        .then(() => {
          this.showDeleteSuccessAlert = true;
          this.deleteDialog = false;
          this.$store.dispatch("setActiveItem", {
            date: new Date().toISOString().substr(0, 10),
            period: new Date().toISOString().substr(0, 7),
            from_account_id: "",
            to_account_id: "",
            transaction_category_id: "",
            amount: "",
            description: "",
            type: "expense",
          });
        })
        .catch((result) => {
          this.parseErrors(result);
        });
    },
  },
  computed: {
    ...mapGetters([
      "projects",
      "accounts",
      "transactions",
      "transactionCategories",
      "activeProject",
      "activeProjectId",
      "balances",
    ]),
    activeAccounts() {
      return this.accounts.filter(
        (account) => account.project_id === this.activeProjectId
      );
    },
    minDate() {
      if (this.fromDate) {
        return new Date(this.fromDate);
      }

      return new Date().subtractDays(3);
    },
    maxDate() {
      if (this.toDate != "") {
        return new Date(this.toDate);
      }

      return new Date().addDays(3);
    },
    firstBalance() {
      return this.balances[this.fromDate];
    },
    lastBalance() {
      return this.balances[this.toDate];
    },
    selectedAccounts() {
      let text = "";
      this.accounts
        .filter((el) => this.jurnal_accounts.includes(el.id))
        .forEach((item) => {
          text += item.name + ", ";
        });
      return text.substring(0, text.length - 2);
    },
  },
  watch: {
    activeProjectId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.refreshData();
      }
    },
  },
};
</script>
<style>
.vuecal__title-bar {
  background-color: #1976d2 !important;
  color: #ffffff;
}

.vuecal__weekdays-headings {
  padding: 0 !important;
}

.vuecal__heading {
  border-left: 1px solid hsla(0, 0%, 76.9%, 0.25);
  border-right: 1px solid hsla(0, 0%, 76.9%, 0.25);

  border-collapse: collapse;
}
</style>
